/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// we need to use tabindex on popup ^^ so it could be interactable right away
// when it's appears
import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import InlineSVG from 'svg-inline-react';
import group from '../../assets/images/group.svg';
import school from '../../assets/images/school.svg';
import mclass from '../../assets/images/mclass.svg';
import {
    navigateToReadingClassroomReports,
    navigateToSpanishClassroomReports,
    changeClasses,
    changeSchool,
} from '../../common/navigation/navigation';
import { useAppConfigContext } from '../../common/contexts/AppConfigContext';
import { useAppContext } from '../../common/contexts/AppContext';
import getHelpLinks from '../../common/utils/getHelpLinks';
import { ESPANOL } from '../../constants/applications';

import { getFocusableElementsList, handleTabKeyPress } from '../../common/popups/utils';

const StaffBurgerList = ({ staff, institution }) => {
    // TODO: not using Button component because there is a problem with prefixing styles while deploying

    const modalRef = useRef(null);

    useEffect(() => {
        const modalElement = modalRef.current;
        // apply focus to popup in order to operate popup buttons
        modalElement.focus();
        const [firstElement, lastElement] = getFocusableElementsList(modalElement);
        modalElement.addEventListener('keydown', handleTabKeyPress(firstElement, lastElement));

        const links = modalElement.querySelectorAll('.link');

        if (links.length !== 0) {
            links.forEach(button => button.setAttribute('tabindex', '0'));
        }

        return () => {
            modalElement.removeEventListener(
                'keydown',
                handleTabKeyPress(firstElement, lastElement),
            );
        };
    }, []);

    const { edition, appConfigs, appPmConfigs } = useAppConfigContext();
    const { selectedAppGroup } = useAppContext();
    const helpLinks = getHelpLinks(edition, appConfigs, appPmConfigs);
    const navigateToReports = useCallback(() => {
        if (selectedAppGroup === ESPANOL) {
            navigateToSpanishClassroomReports();
        } else {
            navigateToReadingClassroomReports();
        }
    }, [selectedAppGroup]);

    return (
        <div className='dashboard-staff-burger-list' ref={modalRef}>
            <div className='dashboard-staff-name'>{`${staff.firstName} ${staff.lastName}`}</div>
            <div className='dashboard-link-list'>
                <button type="button" onClick={changeClasses} className='dashboard-link'>
                    <InlineSVG className='dashboard-icon' src={group} /> Class Selection
                </button>
                {institution.hasMultipleInstitutions && (
                    <button type="button" onClick={changeSchool} className='dashboard-link'>
                        <InlineSVG className='dashboard-icon' src={school} /> School Selection
                    </button>
                )}
                <button type="button" onClick={navigateToReports} className='dashboard-link'>
                    <InlineSVG className='dashboard-mclass-icon' src={mclass} /> Reports
                </button>
                <div className='dashboard-online-help-title'>
                    <span className='dashboard-title-text'>Online Help</span>{' '}
                    <div className='dashboard-list-title-line' />
                </div>
                <div className='dashboard-online-help-section'>
                    {helpLinks.map(item => (
                        <button
                            type="button"
                            onClick={item.handleClick}
                            className='dashboard-link'
                            key={item.title.replace(/\s/g, '')}
                        >
                            <span className='dashboard-item-text'>{item.title}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

StaffBurgerList.defaultProps = {
    institution: {
        hasMultipleInstitutions: false,
    },
};

StaffBurgerList.propTypes = {
    staff: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
    }).isRequired,
    institution: PropTypes.shape({
        hasMultipleInstitutions: PropTypes.bool,
    }),
};

export default StaffBurgerList;
